<template>
  <v-tooltip
    v-if="mini"
    right
  >
    <template v-slot:activator="{ on, attrs }">
      <v-list-item
        :href="item.href"
        :rel="item.href ? 'nofollow' : undefined"
        :target="item.href ? '_blank' : undefined"
        :to="item.to"
        active-class="drawerSelection"
        link
        class="py-1 font-weight-medium"
        v-bind="{ ...$attrs, ...attrs }"
        v-on="{ ...$listeners, ...on }"
      >
        <v-list-item-icon v-if="!item.icon" class="text-caption text-uppercase justify-center ml-1 my-2 align-self-center">
          {{ title }}
        </v-list-item-icon>
        <v-list-item-avatar v-if="item.avatar">
          <v-img :src="item.avatar" />
        </v-list-item-avatar>

        <v-list-item-icon v-if="item.icon" class="my-2 align-self-center">
          <v-icon class="secondary--text" v-text="item.icon" />
        </v-list-item-icon>

        <v-list-item-content v-if="item.title">
          <v-list-item-title class="secondary--text">{{ $t(item.title) }}</v-list-item-title>
        </v-list-item-content>
      </v-list-item>
    </template>
    <span>{{ item.title ? $t(item.title) : '' }}</span>
  </v-tooltip>

  <v-list-item
    v-else
    :href="item.href"
    :rel="item.href ? 'nofollow' : undefined"
    :target="item.href ? '_blank' : undefined"
    :to="item.to"
    active-class="drawerSelection"
    link
    class="py-1 font-weight-medium"
    v-bind="$attrs"
    v-on="$listeners"
  >
    <v-list-item-icon v-if="!item.icon" class="text-caption text-uppercase justify-center ml-1 my-2 align-self-center">
      {{ title }}
    </v-list-item-icon>
    <v-list-item-avatar v-if="item.avatar">
      <v-img :src="item.avatar" />
    </v-list-item-avatar>

    <v-list-item-icon v-if="item.icon" class="my-2 align-self-center">
      <v-icon class="secondary--text" v-text="item.icon" />
    </v-list-item-icon>

    <v-list-item-content v-if="item.title">
      <v-list-item-title class="secondary--text">{{ $t(item.title) }}</v-list-item-title>
    </v-list-item-content>
  </v-list-item>
</template>

<script>
  export default {
    name: 'DefaultListItem',

    props: {
      item: {
        type: Object,
        default: () => ({}),
      },
      mini: {
        type: Boolean,
        default: false,
      },
    },

    computed: {
      title () {
        if (!this.item.title) return ''
        const matches = this.item.title.match(/\b(\w)/g)
        return matches ? matches.join('') : ''
      },
    },
  }
</script>
